import { AbstractControl } from '@angular/forms';
import {
  CpfValidator,
  CnpjValidator,
  SpecialCharactersValidator,
  PasswordStrengthValidator,
  TelephoneCellphoneValidator,
  OverEighteenValidator,
  DateValidator,
} from './functions';

export class CustomValidators {
  static cpf(control: AbstractControl): any | null {
    return CpfValidator()(control);
  }

  static cnpj(control: AbstractControl): any | null {
    return CnpjValidator()(control);
  }

  static specialCharacters(control: AbstractControl): any | null {
    return SpecialCharactersValidator()(control);
  }

  static passwordStrength(control: AbstractControl): any | null {
    return PasswordStrengthValidator()(control);
  }

  static telephoneCellphone(control: AbstractControl): any | null {
    return TelephoneCellphoneValidator()(control);
  }

  static overEighteen(control: AbstractControl): any | null {
    return OverEighteenValidator()(control);
  }

  static date(control: AbstractControl): any | null {
    return DateValidator()(control);
  }
}
